import React from 'react'
import { Button, FormInstance, Modal } from 'antd';
import { TFunction } from 'i18next';
import classes from './TermsModal.module.scss';
import PDFViewer from 'components/Webviewer/Viewer/PDFViewer';
import { cookieAgreements, BuildNames, Languages } from 'interfaces/IBuildLanguage';
import { getTheme } from 'helpers/getTheme';
import cn from 'classnames';

// @ts-ignore
const buildName: BuildNames = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || 'tazadeal';

type CookieModalProps = {
  isCookieModalOpen?: boolean;
  setIsCookieModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  t: TFunction;
  form: FormInstance<any>;
};

export default function CookieModal(
  {
    isCookieModalOpen,
    setIsCookieModalOpen,
    t,
    form,
  }: CookieModalProps
) {
  const [isAvailableAccept, setIsAvailableAccept] = React.useState<boolean>(true);
  const isAlreadyAccept = form.getFieldValue(['is_accepted_cookie']);

  const footerWithAcceptButton = (
    <Button
      disabled={!isAvailableAccept}
      type='primary'
      onClick={() => {
        form.setFieldsValue({ is_accepted_cookie: true });
        form.validateFields(['is_accepted_cookie']);
        setIsCookieModalOpen(false);
      }}
    >
      {t('Confirm.acceptCookies')}
    </Button>
  )

  return (
    <Modal
      className={cn(classes.modalLicense, getTheme())}
      width={'90%'}
      onCancel={() => setIsCookieModalOpen(false)}
      title={t('PersonalInfo.cookieTitle')}
      open={isCookieModalOpen}
      centered={true}
      footer={isAlreadyAccept ? null : footerWithAcceptButton}
    >
      <div style={{height: '85vh'}}>
        <PDFViewer
          url={cookieAgreements[buildName][Languages.Ru]} // [i18n.language as Languages] // useTranslation()
          isModal={false}
          // setIsAvailableAccept={setIsAvailableAccept}
        />
      </div>
    </Modal>
  )
};
